import React from 'react';
import { motion } from 'framer-motion';
import { X, Truck } from 'lucide-react';

const TrackingModal = ({ trackingModal, trackingNumber, setTrackingNumber, carrier, setCarrier, onSubmit, onSkip, onClose }) => {
  if (!trackingModal) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-testid="tracking-modal-overlay">
      <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="bg-background rounded-2xl border border-border p-8 w-full max-w-md mx-4 shadow-xl" data-testid="tracking-modal">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-foreground" style={{ fontFamily: 'Outfit, sans-serif' }}>Add Tracking Info</h2>
          <button onClick={onClose} className="p-1 hover:bg-muted rounded-lg transition-colors" data-testid="close-tracking-modal">
            <X className="w-5 h-5" />
          </button>
        </div>
        <p className="text-sm text-foreground/60 mb-6">Order #{trackingModal} — Mark as Shipped</p>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Carrier</label>
            <select value={carrier} onChange={(e) => setCarrier(e.target.value)} className="w-full px-4 py-3 rounded-lg border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary text-sm" data-testid="tracking-carrier-select">
              <option value="Australia Post">Australia Post</option>
              <option value="Aramex">Aramex</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-foreground mb-1">Tracking Number</label>
            <input type="text" value={trackingNumber} onChange={(e) => setTrackingNumber(e.target.value)} placeholder="e.g. AP123456789AU" className="w-full px-4 py-3 rounded-lg border border-border bg-background focus:outline-none focus:ring-2 focus:ring-primary text-sm" data-testid="tracking-number-input" />
          </div>
        </div>
        <div className="flex space-x-3 mt-6">
          <button onClick={onSkip} className="flex-1 px-4 py-3 rounded-lg border border-border text-foreground hover:bg-muted transition-colors text-sm font-medium" data-testid="skip-tracking-button">
            Skip — No Tracking
          </button>
          <button onClick={onSubmit} disabled={!trackingNumber.trim()} className="flex-1 px-4 py-3 rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 transition-colors text-sm font-medium disabled:opacity-50" data-testid="submit-tracking-button">
            Ship with Tracking
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default TrackingModal;
